import React from 'react'
import CommonFooter from '../../components/CommonFooter/CommonFooter'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'
const BookingAgriDrone = () => {
  return (
    <>
      <CommonNavbar />
      <div className='py-5'>
        <div className='container px-md-5'>
          <div className='p-8 bg-white text-gray-800 leading-relaxed'>
            {/* Heading */}
            <h1 className='text-3xl font-bold text-green-900 mb-6 clr_dark_green'>
              Booking of Agri-Drone
            </h1>

            {/* Intro */}
            <p className='mb-6'>
              Farmer’s City (FC) enables efficient crop monitoring and precision
              agriculture through our Agri-Drone services. Our drone pilots are
              equipped to perform various tasks, such as:
            </p>

            {/* Services List */}
            <ul className='list-disc list-inside mb-6 space-y-2'>
              <li>Crop Spraying</li>
              <li>Surveillance</li>
              <li>Land Survey</li>
            </ul>

            <p className='mb-6'>
              You can now conveniently book these services through our mobile
              application or visit one of our franchise stores.
            </p>

            {/* Microfinance Features */}
            <h2 className='text-2xl font-semibold text-green-900 mb-4 clr_dark_green'>
              Microfinance Features
            </h2>
            <ol className='list-decimal list-inside mb-6 space-y-2'>
              <li>
                Download the Farmer’s City App or visit a nearby franchise
                store.
              </li>
              <li>
                Register yourself as a farmer or request a demo if you’re new to
                drone applications.
              </li>
              <li>
                Browse our selection of drone services and choose the
                appropriate package for your needs.
              </li>
              <li>Schedule your preferred date and time for the service.</li>
              <li>Pay securely online or at the store.</li>
            </ol>

            {/* Process Explanation */}
            <p className='mb-6'>
              Once you complete the booking process, our drone pilots will
              receive an alert and confirm the appointment. You’ll receive
              updates throughout the entire process, ensuring seamless
              communication and peace of mind.
            </p>
          </div>
        </div>
      </div>
      <CommonFooter />
    </>
  )
}

export default BookingAgriDrone
